import { FormField } from "./form-field.js";

/**
 * Select — native <select>. `options` items are `{ value, label, disabled? }`;
 * pass a first option with `value: ""` as a "choose one" placeholder when
 * there's no sensible default.
 */
export function Select({ id, label, value = "", options, hint, error, required = false, onChange }) {
  const select = document.createElement("select");
  select.id = id;
  select.name = id;
  select.className = "form-control";
  if (error) select.classList.add("form-control-error");

  for (const opt of options) {
    const optionEl = document.createElement("option");
    optionEl.value = opt.value;
    optionEl.textContent = opt.label;
    if (opt.disabled) optionEl.disabled = true;
    select.append(optionEl);
  }
  select.value = value;

  if (onChange) {
    select.addEventListener("change", () => onChange(select.value));
  }

  return FormField({ id, label, required, hint, error, control: select });
}
